import { Directive } from '@angular/core';

@Directive({
    selector: '[tidyDragDropItem]',
    standalone: false
})
export class DragDropItemDirective {
}
